export const meta = { id: 'O35', slug: 'administrar-planos', title: 'Como administrar Planos', description: 'Acompanhe objetivos, Competências, metas, ações e relações com a Jornada na visão administrativa.', profile: 'owner', category: 'operacao', type: 'screen', status: 'published', order: 650, keywords: ['planos','objetivos','metas','ações','jornada','gestão'], previous: 'O34.1', next: 'O36', related: ['A04','M05'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como administrar Planos

A visão administrativa de Planos permite compreender como objetivo, Competências, metas, ações e Jornada se conectam dentro do desenvolvimento.

<HelpImage pendingId="O35.1" alt="Visão administrativa de Planos" />

## O que observar

- objetivo principal;
- Competências priorizadas;
- metas e ações;
- relação com a Jornada;
- situação de acompanhamento e progresso.

<Callout type="important">A administração do Plano não substitui a experiência do Aluno nem o acompanhamento do Mentor. Cada perfil utiliza essas informações dentro da própria alçada.</Callout>
